<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Contacten</h2>
    <button *appHasPermission="'contact:create'" mat-button class="ml-auto" (click)="handleContactAdd()">
      <mat-icon>add</mat-icon>

      Nieuw contact
    </button>
  </div>

  <div class="bg-white p-4 rounded-t-lg">
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        placeholder="Zoeken op naam, telefoonnummer of e-mailadres..."
        [disabled]="isSearchDisabled()"
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <app-data-table-container class="rounded-b-lg!">
    <table
      mat-table
      matSort
      matSortDirection="asc"
      matSortActive="name"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="name" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Naam</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.name"
            matTooltipPosition="after"
            >{{ element.name }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef>Telefoonnummer</th>
        <td mat-cell *matCellDef="let element">
          {{ element.phoneNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>E-mailadres</th>
        <td mat-cell *matCellDef="let element">
          {{ element.email ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell mat-sort-header="created_at" *matHeaderCellDef>
          Aangemaakt op
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell mat-sort-header="updated_at" *matHeaderCellDef>
          Laatst bewerkt op
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.updatedAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div>
            <button *appHasPermission="['contact:update', 'contact:delete']" mat-icon-button matTooltip="Meer" [matMenuTriggerFor]="actionMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>

          <mat-menu #actionMenu="matMenu">
            <button *appHasPermission="'contact:update'" mat-menu-item (click)="handleContactUpdate(element)">
              Bewerken
            </button>
            <button *appHasPermission="'contact:delete'" mat-menu-item (click)="handleContactDelete(element)">
              Verwijderen
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:bg-gray-100! whitespace-nowrap"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
